import { createGlobalStyle } from "styled-components";
import GilroyBold from "../assets/fonts/Gilroy-Bold.ttf";
import GilroySemiBold from "../assets/fonts/Gilroy-SemiBold.ttf";
import GilroyRegular from "../assets/fonts/Gilroy-Regular.ttf";

export const FontsImport = createGlobalStyle`
  @font-face {
    font-family: 'gilroyBold';
    src: url(${GilroyBold}) format('truetype');
    font-style: normal;
  }
    @font-face {
    font-family: 'gilroyRegular';
    src: url(${GilroyRegular}) format('truetype');
    font-style: normal;
  }
    @font-face {
    font-family: 'gilroySemiBold';
    src: url(${GilroySemiBold}) format('truetype');
    font-style: normal;
  }
`;
export const fonts = {
  gilroyBold: "gilroyBold",
  gilroyRegular: "gilroyRegular",
  gilroySemiBold: "gilroySemiBold",
};

export const fontSize = {
  xsm: "13px",
  sm: "0.475em",
  mm: "0.875em",
  md: "1.25em",
  md2: "1.625em",
  lg: "2.1875em",
  xlg: "2.625em",
  xxlg: "3.75em",
  base: "12px",
};

export const devices = {
  mobileS: `(max-width: 320px)`,
  mobileM: `(max-width: 375px)`,
  mobileL: `(max-width: 425px)`,
  mobileXL: `(max-width: 430px)`,
  tablet: `(max-width: 1023px)`,
  laptop: `(min-width: 1024px)`,
  laptopL: `(max-width: 1440px)`,
  laptopS: `(max-width: 1470px)`,
  desktop: `(max-width: 2560px)`,
};
export const colors = {
  blue: {
    primary: "#4280EF",
  },
  brown: {
    capivara: "#c6a25c",
    primary: "#231f20",
    primaryDisabled: "#6b6768",
    secundary: "#fefcf8",
    capivaraLight: "#e9bb6d",
    capivaraLightAux: "#f7e7cc",
  },
  palete: {
    brownDark: "#231f20",
    brownLight: "#42372b",
    brownLighter: "#f9ebd4",
    brownExtraLighter: "#fdf8f0",
    gold: "#C6A25C",
    tableOdd: "#F2ECE2",
    green: "#008000",
    greenHover: "#007300",
    red: "#B85242",
    redHover: "#9C4638",
  },
};
export default {
  fontSize,
  devices,
  colors,
  fonts,
};
